import { UserStatus } from './enums/UserStatus';
export class Presence {
    constructor({ status = UserStatus.Unknown, description = '' }) {
        this.status = UserStatus.Unknown;
        this.description = '';
        this.status = status;
        this.description = description;
    }
}
